module.exports = __webpack_public_path__ + "static/media/Chrome-icon.86f49ad5.png";